"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
/**
 *
 *
 * @class Timer
 */
var Timer = /** @class */ (function () {
    function Timer() {
    }
    /**
     * タイマーを開始
     *
     * @static
     * @param {(string | undefined)} [id=undefined] ID値（複数のタイマーを使用したい場合）
     * @memberof Timer
     */
    Timer.start = function (id) {
        if (id === void 0) { id = undefined; }
        // 開始を記録
        if (id) {
            this.startDateList[id] = Date.now();
        }
        else {
            this.startDate = Date.now();
        }
    };
    /**
     * タイマーを停止
     *
     * @static
     * @param {(string | undefined)} [id=undefined] ID値（複数のタイマーを使用したい場合）
     * @param {('second' | 'millisecond')} [type='second'] 返却タイプ：秒 または ミリ秒を指定可能
     * @return {*}  {number} 経過秒(Second)を返します
     * @memberof Timer
     */
    Timer.stop = function (id, type) {
        if (id === void 0) { id = undefined; }
        if (type === void 0) { type = 'second'; }
        var newTimeMs = Date.now();
        var diffMs = 0;
        // 差を計算
        if (id) {
            if (this.startDateList[id]) {
                diffMs = newTimeMs - this.startDateList[id];
                delete this.startDateList[id];
            }
        }
        else {
            if (this.startDate) {
                diffMs = newTimeMs - this.startDate;
                this.startDate = undefined;
            }
        }
        var result = diffMs;
        if (type == 'second') {
            result = diffMs == 0 ? 0 : Math.floor(diffMs / 1000);
        }
        return result;
    };
    /**
     * Promises式タイマーを返します
     * @returns {Promise} クエリ文字列
     */
    Timer.wait = function (interval) {
        return new Promise(function (resolve) { return setTimeout(resolve, interval); });
    };
    // 開始時間保持（IDによる複数用）
    Timer.startDateList = {};
    return Timer;
}());
exports.Timer = Timer;
//# sourceMappingURL=Timer.js.map